var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchTagProgramBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1886_174822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 12.0393C3.25121 11.5478 4.2169 11.2891 5.1999 11.2891C6.18291 11.2891 7.14859 11.5478 7.9999 12.0393C8.85121 11.5478 9.8169 11.2891 10.7999 11.2891C11.7829 11.2891 12.7486 11.5478 13.5999 12.0393",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.12,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 3.95045C3.25121 3.45895 4.2169 3.2002 5.1999 3.2002C6.18291 3.2002 7.14859 3.45895 7.9999 3.95045C8.85121 3.45895 9.8169 3.2002 10.7999 3.2002C11.7829 3.2002 12.7486 3.45895 13.5999 3.95045",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.12,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 3.9502V12.0391",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.12,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.9502V12.0391",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.12,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6001 3.9502V12.0391",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.12,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1886_174822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchTagProgramBlack);
export default __webpack_public_path__ + "static/media/icon_search_tag_program_black.11b55194a5638afde5be5cf38ae13f6b.svg";
export { ForwardRef as ReactComponent };